import React, { createContext, useContext, useEffect } from 'react';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ socket, children }) => {
  useEffect(() => {
    if (socket) {
      socket.connect();

      socket.on('connect', () => {
        console.log('🔌 Connected to TradeBet server');
      });

      socket.on('disconnect', () => {
        console.log('🔌 Disconnected from TradeBet server');
      });

      return () => {
        socket.disconnect();
      };
    }
  }, [socket]);

  const value = {
    socket,
    isConnected: socket?.connected || false
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};